export interface Testimonial {
  id: number;
  quote: string;
  name: string;
  title: string; // Title/Company at the time of recommendation
}

export const testimonials: Testimonial[] = [
  {
    id: 1,
    quote: "Not only does Adam deliver projects on time and within budget, he also thinks very strategically and empowers his stakeholders... What set him aside from other PM’s, he thinks ahead on other areas within the business that we can add value which is a rare skill set.",
    name: "Mahbub A.",
    title: "Director Of CRM Marketing & Business Strategy (Ex-British Gas)"
  },
  {
    id: 2,
    quote: "Adam combines strong analytical skills with intellect and great stakeholder management to really understand how to unpick and solve complex issues. Just a really talented person.",
    name: "Aash P.",
    title: "Helping companies meet strategic ambitions"
  },
  {
    id: 3,
    quote: "Adam needed very little oversight and is very adaptable... equally comfortable manipulating data as he is articulating complex messages in creative slides. In the space of 4 weeks he established a root cause analysis capability for a client...",
    name: "Adam P.",
    title: "Director | Data Science | Management Consultant"
  },
  {
    id: 4,
    quote: "Adam is an intensely passionate and hard-worker who utilises a combination of strong technical know-how to match his communication skills. He consistently went above and beyond to find the best solution...",
    name: "Dan C.",
    title: "Managing Owner at The Open Book Editor"
  },
  {
    id: 5,
    quote: "Adam is extremely client focused with a high sense of business awareness and is very IT savvy... flexible in working in a number of different areas... Business Analysis, Test Management, Customer Demonstrations as well as understanding the technical detail...",
    name: "Balkar S.",
    title: "Solution Architect"
  },
  {
    id: 6,
    quote: "Adam was core to the team achieving success within the tight timescales, demonstrating the necessary capability and confidence to proactively engage with all business stakeholders. A key strength is Adams positive work ethic...",
    name: "Maxine R.",
    title: "Business Analysis / Enterprise Architecture"
  }
];
